import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ConfirmarUsuarioDialogComponent, ConfirmarUsuarioDialogDataClose } from 'src/app/shared/components/confirmar-usuario-dialog/confirmar-usuario-dialog.component';
import { EscolherFormaPgtoDialogComponent, EscolherFormaPgtoDialogDataClose } from 'src/app/shared/components/escolher-forma-pgto-dialog/escolher-forma-pgto-dialog.component';
import { LocalizarClientesComponent, LocalizarClientesDataClose } from 'src/app/shared/components/localizar-clientes/localizar-clientes.component';
import { ObservacoesProdutoComponent, ObservacoesProdutoDataClose } from 'src/app/shared/components/observacoes-produto/observacoes-produto.component';
import { SelecionarEnderecoDeliveryDataClose, SelecionarEnderecoDeliveryDialogComponent } from 'src/app/shared/components/selecionar-endereco-delivery-dialog/selecionar-endereco-delivery-dialog.component';
import { ValorRecebidoTrocoDataClose, ValorRecebidoTrocoDialogComponent } from 'src/app/shared/components/valor-recebido-troco-dialog/valor-recebido-troco-dialog.component';
import { ModalResult } from 'src/app/shared/interfaces/modal-result.interface';
import { PedidoModel } from 'src/app/shared/models/pedido.model';
import { EnderecoPessoa } from 'src/app/shared/models/pessoa.model';
import { VendasDetalheModel } from 'src/app/shared/models/vendas-detalhe.model';
import { DialogStateUtil } from 'src/app/shared/utils/dialog-state.util';

@Injectable({
  providedIn: 'root'
})
export class ModaisService {
  constructor(
    private _modalCtrl: ModalController
  ) { }

  public async modalConfirmarUsuarioDialogAsync() {
    const modal = await this._modalCtrl.create({
      component: ConfirmarUsuarioDialogComponent,
      id: ModaisIdEnum.CONFIRMAR_USUARIO,
      backdropDismiss: false,
    });

    await modal.present();

    DialogStateUtil.dialogIsOpen();

    const modalResult = await modal.onWillDismiss() as ModalResult<ConfirmarUsuarioDialogDataClose>;

    DialogStateUtil.dialogIsClosed();

    return modalResult;
  }

  public async modalEscolherFormaPgtoAsync(pedido: PedidoModel) {
    const modal = await this._modalCtrl.create({
      component: EscolherFormaPgtoDialogComponent,
      id: ModaisIdEnum.ESCOLHER_FORMA_PGTO,
      cssClass: 'custom-modal',
      componentProps: {
        pedido
      },
      backdropDismiss: false,
    });

    await modal.present();

    DialogStateUtil.dialogIsOpen();

    const modalResult = await modal.onWillDismiss() as ModalResult<EscolherFormaPgtoDialogDataClose>;

    DialogStateUtil.dialogIsClosed();

    return modalResult;
  }

  public async modalObservacoesProdutoAsync(det: VendasDetalheModel) {
    const modal = await this._modalCtrl.create({
      component: ObservacoesProdutoComponent,
      id: ModaisIdEnum.OBSERVACOES_PRODUTO,
      componentProps: {
        det
      },
      cssClass: 'full-screen-dialog',
    });

    await modal.present();

    DialogStateUtil.dialogIsOpen();

    const modalResult: ModalResult<ObservacoesProdutoDataClose> = await modal.onWillDismiss();

    DialogStateUtil.dialogIsClosed();

    return modalResult;
  }

  public async modalSelecionarClienteAsync() {
    const modal = await this._modalCtrl.create({
      component: LocalizarClientesComponent,
      id: ModaisIdEnum.SELECIONAR_CLIENTE,
      cssClass: 'full-screen-dialog',
      backdropDismiss: false,
      keyboardClose: false,
    });

    await modal.present();

    DialogStateUtil.dialogIsOpen();

    const modalResult: ModalResult<LocalizarClientesDataClose> = await modal.onWillDismiss();

    DialogStateUtil.dialogIsClosed();

    return modalResult;
  }

  public async modalSelecionarEnderecoAsync(enderecos: EnderecoPessoa[]) {
    const modal = await this._modalCtrl.create({
      component: SelecionarEnderecoDeliveryDialogComponent,
      id: ModaisIdEnum.SELECIONAR_ENDERECO,
      componentProps: {
        enderecos
      },
      cssClass: 'custom-modal-h50',
      backdropDismiss: false,
    });

    await modal.present();

    DialogStateUtil.dialogIsOpen();

    const modalResult = await modal.onWillDismiss() as ModalResult<SelecionarEnderecoDeliveryDataClose>;

    DialogStateUtil.dialogIsClosed();

    return modalResult;
  }

  public async modalValorRecebidoTrocoAsync(valorAPagarEmReais: number) {
    const modal = await this._modalCtrl.create({
      component: ValorRecebidoTrocoDialogComponent,
      id: ModaisIdEnum.VALOR_RECEBIDO_TROCO,
      componentProps: {
        valorAPagarEmReais
      },
      cssClass: 'valor-recebido-troco-dialog',
      backdropDismiss: false,
    });

    await modal.present();

    DialogStateUtil.dialogIsOpen();

    const modalResult = await modal.onWillDismiss() as ModalResult<ValorRecebidoTrocoDataClose>;

    DialogStateUtil.dialogIsClosed();

    return modalResult;
  }
}

export enum ModaisIdEnum {
  SELECIONAR_ENDERECO = 'modalSelecionarEndereco',
  SELECIONAR_CLIENTE = 'modalSelecionarCliente',
  ESCOLHER_FORMA_PGTO = 'modalEscolherFormaPgto',
  MONTAR_ITEM = 'modalMontarItem',
  VALOR_RECEBIDO_TROCO = 'modalValorRecebidoTroco',
  OBSERVACOES_PRODUTO = 'modalObservacoesProduto',
  CONFIRMAR_USUARIO = 'modalConfirmarUsuario',
}
